import { copyTextToClipboard, useCopyToClipboardNotification } from '@capsicum/common';

import { Snackbar } from '../../ui/molecules/snackbar/Snackbar';

type UseCopyToClipboardProps = {
	label: string;
	value: string;
};

export function useCopyToClipboard({ label, value }: UseCopyToClipboardProps) {
	const { showCopyToClipboardNotification } = useCopyToClipboardNotification({
		component: (
			<Snackbar description={label} hasAnimatedTransition={false} testID="copy-to-clipboard-notification" />
		)
	});

	const copyToClipboard = () => {
		copyTextToClipboard(value);

		showCopyToClipboardNotification();
	};

	return {
		copyToClipboard
	};
}
